import HomeMain from "@/components/home";
import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Homes For Sale | Online Real Estate Auctions | Properties | Hubzu",
};

const HomePage = () => {
  return (
    <div data-page="home">
      <MetaComponent meta={metadata} />
      <HomeMain />
    </div>
  );
};

export default HomePage;
